<template>
  <el-table-column label="邮箱" show-overflow-tooltip min-width="240" class-name="email">
    <template v-slot="{row}">
      <el-tooltip effect="dark" content="复制" placement="top">
        <el-button
          v-if="row[field]"
          type="text"
          icon="el-icon-edit-outline"
          :data-clipboard-text="row[field]"
          @click="$message.success('复制成功')"
        ></el-button>
      </el-tooltip>
      <a :href="`mailto:${row[field]}`">{{row[field]}}</a>
    </template>
  </el-table-column>
</template>

<script>
import ClipboardJS from 'clipboard'

export default {
  props: {
    field: {
      type: String,
      default: 'email'
    }
  },
  data () {
    return {}
  },
  created () {
    this.$clipboard = new ClipboardJS('.email .el-button')
  },
  beforeDestroy () {
    this.$clipboard.destroy()
  }
}
</script>

<style lang="scss">
td[class^='el-table'].email {
  i {
    font-size: 16px;
    position: relative;
    top: 1px;
  }
  .el-button {
    padding: 0;
  }
  a {
    color: inherit;
    margin-left: 4px;
  }
}
</style>
